export default __webpack_public_path__ + "locales/si/SMTPSettings.json?hash=acd549fef5fa923ce386011cf4246449";